import { Store } from "@tanstack/react-store";

const assistantStore = new Store({
    isOpen: false,
    // pendingQuery is submitted automatically on open; pendingPrefill only fills
    // the input and waits for the user to send it consciously.
    pendingQuery: undefined as string | undefined,
    pendingPrefill: undefined as string | undefined,
    // An answer arrived while the assistant was closed (or the tab hidden), not seen yet: the button
    // that opens the assistant, and the conversation in the list, say so.
    unreadAnswer: false,
});

export const openAssistant = (query?: string) => {
    assistantStore.setState((state) => ({
        ...state,
        isOpen: true,
        pendingQuery: query,
        pendingPrefill: undefined,
    }));
};

export const openAssistantWithPrefill = (text?: string) => {
    assistantStore.setState((state) => ({
        ...state,
        isOpen: true,
        pendingQuery: undefined,
        pendingPrefill: text || undefined,
    }));
};

export const closeAssistant = () => {
    assistantStore.setState((state) => ({
        ...state,
        isOpen: false,
        pendingQuery: undefined,
        pendingPrefill: undefined,
    }));
};

export const clearPendingQuery = () => {
    assistantStore.setState((state) => ({
        ...state,
        pendingQuery: undefined,
    }));
};

export const clearPendingPrefill = () => {
    assistantStore.setState((state) => ({
        ...state,
        pendingPrefill: undefined,
    }));
};

export const setUnreadAnswer = (unreadAnswer: boolean) => {
    assistantStore.setState((state) =>
        state.unreadAnswer === unreadAnswer
            ? state
            : { ...state, unreadAnswer },
    );
};

export default assistantStore;
